import React, { useRef, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Badge from '@mui/material/Badge';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";


const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    appBarBottom: {
        top: 'auto',
        bottom: 0,
        [theme.breakpoints.up('sm')]: {
        },
    },
    grow: {
        flexGrow: 1,
    },
    productListPaper: {

        marginBottom: 50,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const materialTheme = createTheme(({
    // set default for now
  }));

function ReturnProductsReview(props) {
    const classes = useStyles();
    const [products, setProducts] = useState(generateSampleProductData());

    const [totalReturnedAmount,setTotalReturnedAmount] = useState(0)
    const [totalItemReturnCount,setTotalItemReturnCount] = useState(0)
    const [showMessageDialog,setShowMessageDialog] = useState(false)
    const [messageDialogMessage,setMessageDialogMessage] = useState("")


    function orderValue(unit) {
        return unit.order_quantity <= 0 ? '' : unit.order_quantity
    }


    const onOrderOrPriceInputOnChange = (product,unit)=>(event)=>{
      
        const productsCopy = [...products]
        const quantity = event.target.value
        unit.returned_quantity = quantity.length <=0 ? 0 : quantity

        product.total_returned_value = computeTotalReturnedAmountPerProduct(product)
        saveOrDeleteLocalStorageTempReturned(product)
        setTotalItemReturnCount(getTotalIteReturnedCount())
        setTotalReturnedAmount(computeOverallTotalReturnedAmount())
       
        setProducts(productsCopy)
  
       
      }
      function computeOverallTotalReturnedAmount(){
        const temporaryReturnedProductsString = localStorage.getItem("temporary_returned_products")
         if(temporaryReturnedProductsString == null){
           return 0
         }
         const temporaryReturnedProducts = JSON.parse(temporaryReturnedProductsString)
         const overallTotalAmount = temporaryReturnedProducts.reduce((partialSum,product)=>partialSum + computeTotalReturnedAmountPerProduct(product),0.00).toFixed(2)
         
         return overallTotalAmount
         
      }

    function computeTotalReturnedAmountPerProduct(product){
        const totalInvoiceValue = Number(product.Units.reduce((partialSum,unit)=> 
          {
            const amount = parseFloat(unit.returned_quantity) * unit.price_with_tax
            return partialSum + (isNaN(amount) ? 0 : amount)
  
          },0.00 ))
        return isNaN(totalInvoiceValue) ? 0 : totalInvoiceValue
    }
    
    function saveOrDeleteLocalStorageTempReturned(product){
        const temporaryReturnedString = localStorage.getItem("temporary_returned_products")
         if(temporaryReturnedString == null){
           localStorage.setItem("temporary_returned_products",JSON.stringify([product]))
           return
         }
         const temporaryReturnedProducts = JSON.parse(temporaryReturnedString)//JSON.parse(localStorage.getItem("temporary_order"))
         const index = temporaryReturnedProducts.findIndex(tempReturnedProduct => tempReturnedProduct.code == product.code && tempReturnedProduct.company_id== product.company_id)
         const totalReturnedAmount = computeTotalReturnedAmountPerProduct(product)
      
         if(index >=0){
           //update
           if(totalReturnedAmount > 0){
            temporaryReturnedProducts.splice(index,1,product) //replace object
    
           }else if(totalReturnedAmount <= 0){
            temporaryReturnedProducts.splice(index,1) //remove object
           }
         
         }else{
           if(totalReturnedAmount > 0){
            temporaryReturnedProducts.push(product)
           }
          
         }
    
         localStorage.setItem("temporary_returned_products",JSON.stringify(temporaryReturnedProducts))
      }
      function getTotalIteReturnedCount(){
        const temporaryReturnedProductsString = localStorage.getItem("temporary_returned_products")
         if(temporaryReturnedProductsString == null){
           return 0
         }
         const temporaryReturnedProducts = JSON.parse(temporaryReturnedProductsString)
    
         const totalOrderedItems = temporaryReturnedProducts.reduce((productWithReturnedPartialCount,product)=>{
           return productWithReturnedPartialCount + product.Units.reduce((partialCount,unit)=>partialCount + (unit.returned_quantity > 0 ? 1 : 0),0)
         },0)
         
         return totalOrderedItems
         
      }

      function orderValue(unit) {
        return unit.returned_quantity == null ||  unit.returned_quantity <= 0 ? '' : unit.returned_quantity
    }

    function returnProductInput(product, unit) {
        return (
            <Box display="flex" justifyContent="flex-end" >
                <Box p={1} display="flex" justifyContent="center" flexDirection="column">
                    <Typography variant="h6" component="span" style={{ fontWeight: 600, fontSize: "16px" }}>{unit.price_with_tax} / <small>{unit.uom}</small></Typography>
                </Box>
                <Box p={1} style={{ maxWidth: "100px" }}>
                    <TextField
                        id="outlined-size-small"
                        variant="outlined"
                        size="small"
                        type="number"
                        value={orderValue(unit)}
                        onChange={onOrderOrPriceInputOnChange(product,unit)}
                    />
                </Box>

            </Box>
        )
    }
    function productElement(product) {
        return (
            <Grid container style={{ padding: "0px" }}>
                <Grid container item xs={12} >
                    < Grid item xs={3} md={2} lg={1} style={{ padding: "4px" }} container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justifyContent="center">
                        <img src={product.image} style={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={9} md={10} lg={11}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="space-between"
                            alignItems="stretch">
                            <Grid item >
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.brand}</Box>
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.name}</Box>

                            </Grid>
                            <Grid item >
                                {
                                    product.Units.map(unit => (
                                        <React.Fragment key={unit.id} >
                                            {returnProductInput(product, unit)}
                                        </React.Fragment>
                                    )
                                    )
                                }


                            </Grid>
                            <Grid item style={{ fontWeight: 600, fontSize: "14px", color: "red" }}>Available: {product.available_inventory} {product.available_inventory_unit}</Grid>
                            <Grid item style={{ fontWeight: 600, fontSize: "14px", color: "green" }}>Total : P {product.total_returned_value}</Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
    function productLists() {
        return (
            <List>
                {
                    products.map(product => (
                        <React.Fragment key={product.id}>
                            <ListItem >
                                {productElement(product)}
                            </ListItem>
                            <Divider light />
                        </React.Fragment>
                    )
                    )
                }
            </List>
        )
    }

    function removeUnitThatHasNoQuantity(temporarySaleInvoiced){
        const filteredProduct = temporarySaleInvoiced.map((product)=>{
          product.Units = product.Units.filter((unit)=>{
              const returnedQuantity = unit.returned_quantity
              
              if(returnedQuantity != null && returnedQuantity>0){
                return true
              }
              return false

              })    
          return product;
        })
         return filteredProduct
    
       }

    function generateSampleProductData() {

        var products = [];

        var product = {};
        product.image = 'https://www.cokebeverages.ph/CokeBeverage/_image.aspx/wQcnMhhsoXCetzWSfFDm0nKC1Qx79qycr8rV0FWoVAU=/2%20-%20ZeroBottle.jpg'
        product.id = new Date().getTime() + Math.floor((Math.random() * 100))
        product.name = `Coca-Cola Zero Sugar 1.5L`
        product.code = `code-1234`
        product.barcode = `123459875454`
        product.short_name = `Coca-Cola Zero Sugar1.5L`
        product.description = `description`
        product.brand = `Coca-cola`
        product.total_order_value = 600
        product.available_inventory = 1000
        product.available_inventory_unit = 'bottle'
        var units = [];
        for (var y = 0; y <= 1; y++) {
            var unit = {};
            unit.id = y
            unit.uom = y == 0 ? 'bottle' : 'case';
            unit.product_code = `code-1234`;
            unit.converted_to_smallest_value = y == 0 ? 1 : 12;
            unit.price_with_tax = y == 0 ? 60 : 720;
            unit.price_without_tax = 10.00;
            //unit.order_quantity = 10

            units.push(unit)
        }
        product.Units = units;
        products.push(product)

        return products;

    }
    
    useEffect(()=>{
       if(!props.openReturnProductsReview){
        return
       }

       const temporaryReturnedProductsString = localStorage.getItem("temporary_returned_products")
    
       if(temporaryReturnedProductsString == null){
         
         return
       }

       const temporaryReturnedProducts = JSON.parse(temporaryReturnedProductsString)
       const modifiedTemporaryReturnedProducts = removeUnitThatHasNoQuantity(temporaryReturnedProducts)
       setTotalItemReturnCount(getTotalIteReturnedCount())
       setTotalReturnedAmount(computeOverallTotalReturnedAmount())

       setProducts(modifiedTemporaryReturnedProducts)
    
  
      },[props.openReturnProductsReview])

      function messageDialog(){
        return(
         
          <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={showMessageDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
             {messageDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{
                setShowMessageDialog(false)
                }} 
              color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        )
    }

    return (
        <div>
            <Dialog fullScreen open={props.openReturnProductsReview} onClose={() => { props.setOpenReturnProductsReview(false) }} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => { props.setOpenReturnProductsReview(false) }}
                            aria-label="close"
                            size="large">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="subtitle1" className={classes.title}>
                            Return Products Review
                    </Typography>
                    </Toolbar>
                </AppBar>
                <div className={classes.appBarSpacer}></div>
                <Paper square className={classes.productListPaper}>
                    {productLists()}
                </Paper>
                <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
                    <Toolbar>
                        <Typography variant="subtitle1" noWrap>
                             Total : {totalReturnedAmount}
                        </Typography>
                        <div className={classes.grow} />

                        <Button variant="contained" onClick={() => { 
                                
                                if(totalItemReturnCount <=0){
                                    setMessageDialogMessage("Please input quantity in product that need to return")
                                    setShowMessageDialog(true)
                                    return
                                }
                                props.setOpenReturnInformationReview(true) 
                            
                            }} >
                            <Typography variant="caption">
                                Finalize Products
                            </Typography>
                            <Badge badgeContent={totalItemReturnCount} color="secondary" style={{ marginLeft: "1rem" }} />
                        </Button>

                    </Toolbar>
                </AppBar>
            </Dialog>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}> {messageDialog()}</ThemeProvider>
            </StyledEngineProvider>

        </div>
    );
}

export default ReturnProductsReview